let settingsAcc = document.getElementsByClassName("sd-form-group");
//let settingsContent = document.getElementsByClassName("sd-form-group-content");
let openSettingsMenu = false;


document.addEventListener("DOMContentLoaded", function() {
   
    if(settingsAcc.length){
        settingsAcc[1].classList.add("active");
        for (let i = 0; i < settingsAcc.length; i++) {
            settingsAcc[i].addEventListener("click", function() {
                /* Toggle between adding and removing the "active" class,
                to highlight the button that controls the panel */
    
                if(!openSettingsMenu){
                    let select = document.getElementById('probability-style');
                    select.value = 'percent';
                    document.getElementById('probability-minimumFractionDigits').value = "0";
                    document.getElementById('probability-maximumFractionDigits').value = "0";
            
                    openSettingsMenu = true;
                }
    
                let c = 0;
        
                while(c < settingsAcc.length){
                    settingsAcc[c++].classList.remove("active");
                }
                this.classList.add("active");
            });
        }
    }
});



// WEBPACK FOOTER //
// ./scripts/components/settings-accordion.js